import * as Yup from 'yup'
import { getExpertPickerValidationSchema } from '@admin/components/ExpertPicker'

export const cmsExpertsWidgetItemValidationSchema = Yup.array().of(
  Yup.object().shape({
    expert: getExpertPickerValidationSchema({ isRequired: true }),
  })
)
